// Common helpers/components for admin pages
import { Link } from "react-router-dom";

export const ESTADO_BADGE = {
  pendente: "bg-amber-50 text-amber-700 border-amber-200",
  confirmada: "bg-sky-50 text-sky-700 border-sky-200",
  concluida: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelada: "bg-zinc-100 text-zinc-700 border-zinc-200",
  no_show: "bg-rose-50 text-rose-700 border-rose-200",
};

export const ESTADO_LABEL = {
  pendente: "Pendente",
  confirmada: "Confirmada",
  concluida: "Concluída",
  cancelada: "Cancelada",
  no_show: "Não compareceu",
};

const DIAS = ["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"];
const MESES = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];

export function formatDate(iso, opts = {}) {
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  const tempo = opts.timeOnly
    ? `${pad(d.getHours())}:${pad(d.getMinutes())}`
    : `${pad(d.getDate())} ${MESES[d.getMonth()]} ${d.getFullYear()} • ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  return tempo;
}

export function formatDateLong(iso) {
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${DIAS[d.getDay()]}, ${d.getDate()} de ${MESES[d.getMonth()]} ${d.getFullYear()} • ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function EstadoBadge({ estado, testId }) {
  return (
    <span
      data-testid={testId || `badge-${estado}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-bold ${ESTADO_BADGE[estado] || "bg-zinc-100 text-zinc-700 border-zinc-200"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {ESTADO_LABEL[estado] || estado}
    </span>
  );
}

export function PageTitle({ children, subtitle }) {
  return (
    <header className="mb-7">
      <h1 className="font-display text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight">{children}</h1>
      {subtitle && <p className="text-[#5A5A5A] mt-1.5">{subtitle}</p>}
    </header>
  );
}

export function Card({ children, className = "", testId }) {
  return (
    <div data-testid={testId} className={`rounded-2xl bg-white border border-[#1E5F6E]/10 p-5 md:p-6 shadow-soft ${className}`}>
      {children}
    </div>
  );
}

export function StatCard({ label, value, hint, testId }) {
  return (
    <Card testId={testId} className="!p-5">
      <div className="text-xs font-bold uppercase tracking-widest text-[#88A096]">{label}</div>
      <div className="mt-2 font-display text-3xl font-extrabold text-[#1A1A1A]">{value}</div>
      {hint && <div className="mt-1 text-xs text-[#5A5A5A]">{hint}</div>}
    </Card>
  );
}

export function ClinicaLabel({ slug }) {
  return slug === "ribeira-brava" ? "Ribeira Brava" : slug === "calheta" ? "Calheta" : slug;
}

export function MarcacaoLink({ id, children }) {
  return (
    <Link to={`/admin/marcacoes/${id}`} className="text-[#1E5F6E] font-semibold hover:underline underline-offset-4">
      {children}
    </Link>
  );
}
